import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import { useAuth } from '../contexts/AuthContext';
import { RefreshCw } from 'lucide-react';

const Layout = () => {
  const { user, isLoading } = useAuth();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background">
        <RefreshCw className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen bg-background overflow-hidden relative">
      {/* Background Image */}
      <div 
        className="absolute bottom-0 left-0 right-0 z-0 pointer-events-none"
        style={{
          backgroundImage: 'url(https://customer-assets.emergentagent.com/job_dark-dashboard-2/artifacts/frxjgsts_imagem%20de%20fundo.png)',
          backgroundSize: '100% auto',
          backgroundPosition: 'bottom center',
          backgroundRepeat: 'no-repeat',
          height: '80%',
          maskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.35) 100%)',
          WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.35) 100%)',
        }}
      />
      
      <Sidebar />
      <div className="flex-1 flex flex-col ml-72 relative z-10 min-w-0">
        <Topbar />
        <main className="flex-1 p-4 lg:p-6 mt-20 overflow-y-auto overflow-x-hidden w-full max-w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
